/**
 * Central de Feature Flags do Sistema
 * Use este arquivo para habilitar ou desabilitar módulos e funcionalidades.
 */
export const FEATURE_FLAGS = {
  // Módulos Principais
  ENABLE_DASHBOARD: true,
  ENABLE_AGENDA: true,
  ENABLE_PATIENTS: true,

  // Módulos Financeiros
  ENABLE_FINANCIAL: true,
  ENABLE_REPORTS: true,
  ENABLE_TISS: true,
  ENABLE_INSURANCES: true,
  ENABLE_EXPENSES: true,

  // Módulos de Gestão e Auditoria
  ENABLE_USERS: true,
  ENABLE_AUDIT: true,

  ENABLE_INSIGHTS: true,
};
